import React, { useState, useRef, useEffect } from "react";
import NavbarManager, { infoUtente, loadNav } from "./Navbar";
import Input from "../../components/Input";
import Toggle from "../../components/Toggle";
import PopUp from "../../components/PopUp";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { RotateCcw, Save, Trash2, Scale, BellRing, SquarePen } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Impostazioni = () => {
    const [isLicenzaVisible, setIsLicenzaVisible] = useState(false);
    const [isCambiaLicenzaVisible, setIsCambiaLicenzaVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState({});
    const [preavviso, setPreavviso] = useState(0);
    const [mailRiepilogo, setMailRiepilogo] = useState(0);
    const [statusToggle, setStatusToggle] = useState(false);
    const [modifiche, setModifiche] = useState(false);
    const [licenza, setLicenza] = useState({});
    const [piano, setPiano] = useState({});
    const [codiceAttivazione, setCodiceAttivazione] = useState("");
    const [isResocontoVisible, setIsResocontoVisible] = useState(false);
    const [infoCodiceAtt, setInfoCodiceAtt] = useState({});
    const toggleRef = useRef(null);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setPreavviso(originalData.GiorniPreavvisoManutenzione);
        if (toggleRef.current) {
            toggleRef.current.setValue(originalData.InvioMailRiepilogo);
            setStatusToggle(originalData.InvioMailRiepilogo);
        }
        setMailRiepilogo(originalData.GiorniMailRiepilogo);
    }, [originalData]);

    useEffect(() => {
        setModifiche(preavviso !== originalData.GiorniPreavvisoManutenzione || statusToggle !== originalData.InvioMailRiepilogo || mailRiepilogo !== originalData.GiorniMailRiepilogo);
    }, [preavviso, mailRiepilogo, statusToggle]);

    useEffect(() => {
        if (isLicenzaVisible) {
            const load = async () => {
                setIsLoading(true);
                try {

                    await loadNav();

                    const r2 = await fetch("/getInfoLicenza", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ CodiceDominio: infoUtente.CodiceDominio }),
                    });

                    const rd2 = await r2.json();

                    if (r2.status === 500) {
                        console.log(rd2.error);
                        setAlertInfo({ type: "error", text: rd2.error, onClose: () => setShowAlert(false), needConfirm: false });
                        setShowAlert(true);
                        setIsLicenzaVisible(false);
                    } else {
                        const r3 = await fetch("/getInfoPiano", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ CodiceDominio: infoUtente.CodiceDominio }),
                        });

                        const rd3 = await r3.json();

                        if (r3.status === 500) {
                            console.log(rd3.error);
                            setAlertInfo({ type: "error", text: rd3.error, onClose: () => setShowAlert(false), needConfirm: false });
                            setShowAlert(true);
                        } else {
                            setLicenza(rd2[0]);
                            setPiano(rd3[0]);
                        }
                    }
                } catch (error) {
                    console.log(error);
                    setAlertInfo({ type: "error", text: "Errore nel caricamento della licenza, riprovare più tardi", onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                }
                setIsLoading(false);
            };

            load();
        }
    }, [isLicenzaVisible]);

    const onload = async () => {
        setIsLoading(true);
        try {
            await loadNav();

            //getParametri
            const r2 = await fetch("/getParametriManager", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente.CodiceDominio }),
            });

            const rd2 = await r2.json();

            if (r2.status === 500) {
                console.log(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setOriginalData(rd2[0]);
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleToggleChange = (newValue) => {
        setStatusToggle(newValue);
    };

    const handleConfirm = async () => {
        let toggleStatus = toggleRef.current?.getValue() ?? false;
        if (!preavviso || (toggleStatus && !mailRiepilogo)) {
            setAlertInfo({ type: "error", text: "Compilare tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch("/aggiornaParametriManager", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    PreavvisoManutenzione: preavviso,
                    InvioMailRiepilogo: toggleStatus,
                    GiorniMailRiepilogo: mailRiepilogo,
                }),
            });

            if (response.status === 500) {
                const rd = await response.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel salvataggio delle impostazioni, riprova più tardi", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleElimina = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const response = await fetch("/eliminaDominio", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente.CodiceDominio }),
                });

                if (response.status === 500) {
                    const rd = await response.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    navigate("/");
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nell'eliminazione del dominio, riprova più tardi", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
                return;
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare il dominio?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const handleNotifica = async () => {
        setIsLoading(true);
        try {
            const r = await fetch('/sendNotificaScadenza', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    Scadenza: licenza['DataScadenza'],
                    EmailManager: infoUtente["Email"]
                }),
            });

            if (r.status === 500) {
                const data = await r.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                setAlertInfo({ type: "success", text: "Notifica inviata con successo", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella connessione al server", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const checkCodice = async () => {
        if (codiceAttivazione.trim() === "" || codiceAttivazione === null) return;
        setIsLoading(true);
        try {
            const response = await fetch('/checkCodiceAttivazione', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceAtt: codiceAttivazione }),
            });

            const data = await response.json();

            if (response.status === 200) {
                setIsLoading(false);
                if (data[0].Obsoleto) {
                    setAlertInfo({ type: "warning", text: 'Licenza obsoleta', onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                    return;
                };

                if (data[0].DataAttivazione !== null) {
                    setAlertInfo({ type: "warning", text: 'Licenza già utilizzata', onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                    return;
                };

                setInfoCodiceAtt(data[0]);
                setIsResocontoVisible(true);
            }
            else {
                setAlertInfo({ type: "error", text: data["error"], onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore di connessione al server, riprovare più tardi", onClose: () => { setShowAlert(false); setIsCambiaLicenzaVisible(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const confirmPopUpModifica = async () => {
        setIsLoading(true);
        try {
            const response = await fetch('/aggiornaLicenzaDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ IDLicenza: infoCodiceAtt.ID, CodiceDominio: infoUtente.CodiceDominio }),
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                setIsLoading(false);
                setAlertInfo({ type: "success", text: "Licenza cambiata con successo", onClose: () => { setShowAlert(false); navigate('/manager/dash') }, needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella connessione al server", onClose: () => { setShowAlert(false); setIsCambiaLicenzaVisible(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    return (
        <div className="h-[100svh]">
            <NavbarManager page={"IMPOSTAZIONI"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4 flex flex-col justify-center items-center">
                <Input
                    label="Preavviso per manutenzione (gg) *"
                    value={preavviso}
                    setValue={setPreavviso}
                    type="text"
                    classes="w-[80%] md:w-[50%]"
                    disabled={false}
                    error={false}
                />
                <div className="w-[80%] md:w-[50%] mt-4 flex items-center justify-between">
                    <span className="text-sm md:text-base">Invio della mail di riepilogo al manager</span>
                    <Toggle ref={toggleRef} onToggleChange={handleToggleChange} />
                </div>
                <Input
                    label="Frequenza di invio della mail (gg) *"
                    value={mailRiepilogo}
                    setValue={setMailRiepilogo}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-2"
                    disabled={!statusToggle}
                    error={false}
                />
                {
                    modifiche && (
                        <div className="w-[80%] md:w-[50%] mt-4 mb-2 grid grid-cols-2 gap-4">
                            <Button type="hollow" onClick={() => window.location.reload()}>
                                RESET <RotateCcw className="inline-block ml-1" />
                            </Button>
                            <Button type="full" onClick={handleConfirm}>
                                SALVA <Save className="inline-block ml-1" />
                            </Button>
                        </div>
                    )
                }
                <div className="w-[80%] md:w-[50%] mt-4 grid grid-cols-2 gap-4">
                    <Button type="hollow" onClick={handleElimina}>
                        ELIMINA DOMINIO <Trash2 size={20} className="inline-block ml-1" />
                    </Button>
                    <Button type="hollow" onClick={() => setIsLicenzaVisible(true)}>
                        LICENZA <Scale size={20} className="inline-block ml-1" />
                    </Button>
                </div>
                <PopUp title="Licenza attiva"
                    isVisible={isLicenzaVisible}
                    setIsVisible={setIsLicenzaVisible}
                    needConfirm={false}
                >
                    <>
                        <div className="flex flex-col items-center">
                            <div className="w-[80%] md:w-[70%] mt-3">
                                <p className="flex justify-between">
                                    Codice Licenza :
                                    <span className="font-semibold">{licenza.CodiceAttivazione}</span>
                                </p>
                                <p className="flex justify-between mt-1">
                                    Piano attivo :
                                    <span className="font-semibold">{piano.Nome}</span>
                                </p>
                                <p className="flex justify-between mt-1">
                                    Descrizione del piano :
                                    <span className="font-semibold">{piano.Descrizione}</span>
                                </p>
                                <p className="flex justify-between mt-1">
                                    Data di attivazione :
                                    <span className="font-semibold">{licenza.DataAttivazione}</span>
                                </p>
                                <p className="flex justify-between mt-1">
                                    Data di scadenza :
                                    <span className="font-semibold">{licenza.DataScadenza}</span>
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-2 mt-2 ">
                            <Button type="hollow" onClick={handleNotifica}>
                                NOTIFICA SCADENZA <BellRing size={20} className="inline ml-1" />
                            </Button>
                            <Button type="hollow" onClick={() => setIsCambiaLicenzaVisible(true)}>
                                CAMBIA LICENZA <SquarePen size={20} className="inline ml-1" />
                            </Button>
                        </div>
                    </>
                </PopUp>
                <PopUp title="Cambia Licenza"
                    isVisible={isCambiaLicenzaVisible}
                    setIsVisible={setIsCambiaLicenzaVisible}
                    needConfirm={false}
                >
                    <div className="flex flex-col items-center">
                        <Input
                            label="Codice di attivazione *"
                            value={codiceAttivazione}
                            setValue={setCodiceAttivazione}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={isResocontoVisible}
                            error={false}
                            blurAction={checkCodice}
                        />
                        {
                            isResocontoVisible && (
                                <>
                                    <p className="mt-2">Revisione del piano</p>
                                    <div className="w-[80%] md:w-[70%] mt-1">
                                        <p className="flex justify-between">
                                            Nome :
                                            <span className="font-semibold">{infoCodiceAtt.Nome}</span>
                                        </p>
                                        <p className="flex justify-between mt-1">
                                            Descrizione :
                                            <span className="font-semibold">{infoCodiceAtt.Descrizione}</span>
                                        </p>
                                    </div>
                                    <Button type="full" classes="w-[80%] md:w-[70%] mt-4 mb-1" onClick={confirmPopUpModifica}>
                                        CONFERMA <Save className="inline-block ml-1" />
                                    </Button>
                                </>
                            )
                        }
                    </div>
                </PopUp>
            </div>

        </div>
    )
};
export default Impostazioni;